import React, { useEffect, useState, Suspense } from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';
import { motion, useScroll, useSpring } from 'framer-motion';
import "./css/bootstrap.min.css";
import "./css/style.css";
import "./css/animate.css";
import "./css/animate.min.css";
import "./css/owl.carousel.min.css";
import "./App.css";
import Loading from './common/Loading';
import WOW from "wow.js";
import ChatGPTMain from './pages/ChatGPT/Main';
// Lazy load the components
import { load } from '@cashfreepayments/cashfree-js';


const MainComponent = React.lazy(() => import('./pages/Main'));
const AboutComponent = React.lazy(() => import('./pages/About'));
const ContactComponent = React.lazy(() => import('./pages/Contact'));
const NewsComponent = React.lazy(() => import('./pages/News'));
const FeatureComponent = React.lazy(() => import('./pages/Feature'));
const PrivacyPolicy = React.lazy(() => import('./pages/privacy-policy'));
const TermsCondition = React.lazy(() => import('./pages/TermsCondition'));
const RefundPolicy = React.lazy(() => import('./pages/RefundPolicy'));
const Header = React.lazy(() => import('./components/Header'));
const FooterComponent = React.lazy(() => import('./pages/Footer'));
const JoinComponent = React.lazy(() => import('./pages/join'));
const TermsAndConditions = React.lazy(() => import('./pages/Tabs/TermsAndConditions_partner'));
const TermsAndConditionsManager = React.lazy(() => import('./pages/Tabs/TermsAndConditions_manager'));
const ExitPage = React.lazy(() => import('./pages/Exit/ExitPage'));

export let cashfree;

let initializeSDK = async function () {
  cashfree = await load({
    mode: "production", // Use "test" for testing environment
  })
}

initializeSDK();

function App() {
  const [isSticky, setIsSticky] = useState(false);
  const location = useLocation();
  const user = JSON.parse(sessionStorage.getItem("user"));
  const { scrollYProgress } = useScroll();

  const hideHeaderFooterRoutes = ['/privacy-policy', '/terms-condition', '/refund-policy','/business-join-our-team-policy','/manager-join-our-team-policy'];

  const shouldHideHeaderFooter = hideHeaderFooterRoutes.includes(location.pathname);

  useEffect(() => {
    const handleScroll = () => {
      setIsSticky(window.scrollY > 0); // if user scrolls down even a little, make it sticky
    };

    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll); // cleanup
    };
  }, []);

  useEffect(() => {
    new WOW().init();
  }, []);

  // Scroll to top function
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth"
    });
  };

  return (
    <div className="container-xxl p-0 site-shell">
      <Suspense fallback={<Loading />}>
        {!shouldHideHeaderFooter && !user && <Header />}

        <Routes>
          <Route path="/" element={<MainComponent />} />
          <Route path="/feature" element={<FeatureComponent />} />
          <Route path="/news" element={<NewsComponent />} />
          <Route path="/join" element={<JoinComponent />} />
          <Route path="/about" element={<AboutComponent />} />
          <Route path="/contact" element={<ContactComponent />} />
          <Route path="/terms-condition" element={<TermsCondition />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/refund-policy" element={<RefundPolicy />} />
          <Route path="/business-join-our-team-policy" element={<TermsAndConditions />} />
          <Route path="/manager-join-our-team-policy" element={<TermsAndConditionsManager />} />
          <Route path="/exit" element={<ExitPage />} />
          <Route path="*" element={<MainComponent />} />
          <Route path="/pension-ai" element={<ChatGPTMain />} />
        </Routes>

        {!shouldHideHeaderFooter && !user && <FooterComponent />}
        <motion.div 
          className="back-to-top-container d-flex align-items-center justify-content-center"
          style={{ 
            display: isSticky ? "flex" : "none", 
            position: "fixed", right: "30px", bottom: "30px", 
            width: "60px", height: "60px", zIndex: 999,
            cursor: "pointer"
          }}
          onClick={scrollToTop}
          whileHover={{ scale: 1.1 }}
          whileTap={{ scale: 0.9 }}
        >
          {/* Background circle */}
          <svg width="60" height="60" viewBox="0 0 100 100" style={{ position: "absolute", top: 0, left: 0, transform: "rotate(-90deg)" }}>
            <defs>
              <linearGradient id="scrollGradient" x1="0%" y1="0%" x2="100%" y2="100%">
                <stop offset="0%" stopColor="#2F2990" />
                <stop offset="100%" stopColor="#A52C94" />
              </linearGradient>
            </defs>
            <circle cx="50" cy="50" r="45" stroke="#e0e0e0" strokeWidth="8" fill="none" />
            <motion.circle 
              cx="50" cy="50" r="45" stroke="url(#scrollGradient)" strokeWidth="8" fill="none" 
              style={{ pathLength: scrollYProgress }} 
              strokeLinecap="round"
            />
          </svg>
          
          <motion.div className="btn btn-primary rounded-circle d-flex align-items-center justify-content-center"
            style={{ width: "40px", height: "40px", margin: "0", padding: "0" }}
          >
            <i className="bi bi-arrow-up text-white fs-4"></i>
          </motion.div>
        </motion.div>
      </Suspense>
    </div>
  );
}

export default App;
